import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { ObjectCard } from '@column/column-ui-kit';

import { ROUTE } from '~/app/routes';
import { useNavigate } from '~/lib/navigation';
import { AccountNumber, BankAccountRepository } from '~/repositories/BankAccountRepository';
import { useSessionStore } from '~/stores/Session';

interface AccountNumberCardProps {
  accountNumberId: string;
}

export const AccountNumberCard: React.FC<AccountNumberCardProps> = ({ accountNumberId }) => {
  const navigate = useNavigate();
  const { currentPlatform } = useSessionStore();

  const {
    data: accountNumber,
    isLoading,
    error,
  } = useQuery<AccountNumber>({
    queryKey: [currentPlatform?.id, 'account-number', accountNumberId],
    queryFn: () => BankAccountRepository.getAccountNumber({ id: accountNumberId }),
    enabled: !!accountNumberId,
    gcTime: 30000,
    staleTime: 10000,
  });

  const handleNavigate = () => {
    if (accountNumber?.bankAccountId) {
      navigate(`${ROUTE.BANK_ACCOUNTS}/edit/${accountNumber.bankAccountId}/info`);
    }
  };

  return (
    <ObjectCard
      error={error ? 'Failed to load account number' : undefined}
      icon="Wallet"
      isLoading={isLoading}
      primaryText={accountNumber?.description || 'Unnamed account number'}
      id={{ label: 'Account Number:', value: accountNumber?.accountNumber || accountNumberId }}
      onClick={handleNavigate}
    />
  );
};
